import React, { useState, useEffect } from "react";
import { Row, Col, Icon, Tooltip, Switch } from "antd";
import { imageUrlPath } from "../Settings";
import Placeholder from "../../media/placeholder.png";
import useFileList from "./useFileList";

const ellipsisText = {
  display: "block",
  maxWidth: "90%",
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
};

const FileList = props => {
  const { materials, onSwitchChange, data, isChecked } = useFileList(props);
  return (
    <div className="filelist--container">
      <Row>
        <Col span={2} />
        <Col span={6}>
          <span data-translationkey="title">Title</span>
        </Col>
        <Col span={2}>
          <span data-translationkey="version">Version</span>
        </Col>
        <Col span={4}>
          <span data-translationkey="size">Modification date</span>
        </Col>
        <Col span={4}>
          <span data-translationkey="status">Status</span>
        </Col>
        <Col span={4} style={{ textAlign: "center" }}>
          <span data-translationkey="processedFile">Processed file</span>
        </Col>
        {data && data.printed && (
          <Col span={2} style={{ textAlign: "center" }}>
            <span data-translationkey="active">Active</span>
          </Col>
        )}
      </Row>
      {materials.map((material, index) => (
        <Row key={index}>
          <Col span={2}>
            <img
              style={{ maxHeight: "50px", padding: "0 10px" }}
              src={
                material.original &&
                material.original[0] &&
                material.original[0].format === "pdf" &&
                material.bigpreview
                  ? imageUrlPath + material.bigpreview.url
                  : Placeholder
              }
              alt="preview"
            />
          </Col>
          <Col span={6}>
            <Tooltip title={material.original && material.inputfilename}>
              <a
                style={ellipsisText}
                href={
                  material.original && imageUrlPath + material.original[0].url
                }
                target="_blank"
              >
                {material.original && material.inputfilename}
              </a>
            </Tooltip>
            <p style={{ opacity: ".5" }}>
              {material.original && material.original[0].width} *{" "}
              {material.original && material.original[0].height} (
              {material.colors})
            </p>
          </Col>
          <Col span={2}>{material.version ? material.version : "n/a"}</Col>
          <Col span={4}>{material.modificationdate}</Col>
          <Col span={4}>{material.status.text}</Col>
          <Col span={4} style={{ textAlign: "center" }}>
            {material.processed ? (
              <a
                href={
                  material && material.processed ? material.processed.url : "#"
                }
                target="_blank"
              >
                <Icon style={{ color: "#2ecc71" }} type="cloud-download" />
              </a>
            ) : (
              <Icon style={{ color: "tomato" }} type="close-circle" />
            )}
          </Col>
          {data && data.printed && (
            <Col span={2} style={{ textAlign: "center" }}>
              {material.id === data.currentmaterial ? (
                <Switch
                  style={{ zoom: ".85" }}
                  size="small"
                  disabled={true}
                  checked={!isChecked}
                />
              ) : (
                <Switch
                  style={{ zoom: ".85" }}
                  value={material.id}
                  onChange={(checked, e) => onSwitchChange(checked, e)}
                  size="small"
                />
              )}
            </Col>
          )}
        </Row>
      ))}
    </div>
  );
};

export default FileList;



// WEBPACK FOOTER //
// ./src/components/FileList/FileList.js